/**
 * Classe para formatar dados do segundos.
 * @author: Adalto Junior
 * DATE: 21/08/2014
 */



Monet.Format = Monet.Format || {};
Monet.Format.SECONDS = (function () {

    function SECONDS(value) {

        Monet.Format.DATE.apply(this, arguments);

        this.value = value;

        this.getHourMinuteAndSeconds = function () {

            return {
                'hours': Math.floor(this.value / 3600),
                'minutes': Math.floor(this.value / 60),
                'seconds': Math.floor(this.value % 60)
            };

        };

        this.formatToElapsedTime = function () {
            const isLessThanZero = this.value < 0;
            const secondAbreviation = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.secondsAbreviation");

            if (isLessThanZero) {
                this.value *= -1;
            }

            const time = this.getHourMinuteAndSeconds();
            const timeFormatted = this.formatTimeParts(time);
            
            this.value = timeFormatted.join(' : ') || (0 + secondAbreviation);

            if (isLessThanZero) {
                this.value =  "-" +  this.value;
            }

            return this;

        };

        this.formatTimeParts = function (time) {
            const timeFormatted = [];
            const language = Monet.I18n.locale.language;
            const isHebrewLanguage = language === "he";
            const hourAbreviation = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.hourAbreviation");
            const minuteAbreviation = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.minuteAbreviation");
            const secondAbreviation = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.secondsAbreviation");
            
            if (time.minutes >= 60) {
                time.minutes = time.minutes % 60;
            }

            if (time.hours > 0) {
                const hourString = isHebrewLanguage ? 
                hourAbreviation + time.hours : time.hours + hourAbreviation;

                timeFormatted.push(hourString);
            }
            
            if (time.minutes) {
                const minutesString = isHebrewLanguage ?
                minuteAbreviation + time.minutes : time.minutes + minuteAbreviation;

                timeFormatted.push(minutesString);
            }
            
            if (time.seconds) {
                const secondsString = isHebrewLanguage ?
                secondAbreviation + time.seconds : time.seconds + secondAbreviation; 

                timeFormatted.push(secondsString);
            }
            
            return timeFormatted;
        }

        this.convertSecondsToHourMinutesSeconds = function () {

            var isLessThanZero,
                prefix = "",
                h = "", m = "", s = "";

            isLessThanZero = this.value < 0;

            if (isLessThanZero) {
                this.value *= -1;
            }

            var time = this.getHourMinuteAndSeconds();

            if (time.minutes >= 60) {
                time.minutes = time.minutes % 60;
            }

            if (time.hours < 10) {
                h = "0";
            }
            if (time.minutes < 10) {
                m = "0";
            }
            if (time.seconds < 10) {
                s = "0";
            }

            h += time.hours.toString();
            m += time.minutes.toString();
            s += time.seconds.toString();

            if (isLessThanZero) {
                prefix = "-";
            }

            this.value = prefix + h + ":" + m + ":" + s;

            return this;

        };

        this.convertHourToSeconds = function () {

            var timeInArray = [],
                h = 0,
                m = 0,
                s = 0,
                hourMinuteSeconds = this.value;

            if (typeof hourMinuteSeconds !== "undefined") {
                timeInArray = hourMinuteSeconds.split(":");
            }

            if (timeInArray[0]) {
                h = parseInt(timeInArray[0] * 3600, 10);
            }

            if (timeInArray[1]) {
                m = parseInt(timeInArray[1] * 60, 10);
            }

            if (timeInArray[2]) {
                s = parseInt(timeInArray[2], 10);
            }

            this.value = h + m + s;

            return this;

        };

        this.convertSecondsToHourMinutes = function () {

            this.convertSecondsToHourMinutesSeconds();

            this.value = this.value.substring(0, this.value.lastIndexOf(':'));

            return this;

        };

        this.getValue = function () {

            if (typeof this.value === 'undefined') {
                this.value = '';
            }

            return this.value;
        };

        this.toGrid = function () {

            this.formatToElapsedTime();

            return this;

        };
    }

    return SECONDS;

}());
